import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';

@Pipe({
    name: 'highlightText'
})
export class HighlightTextPipe implements PipeTransform {

    constructor(private filtersListService: FiltersListService
    ) { }

    transform(value: string, searchValue: any): HighlightItem[] {
        const result: HighlightItem[] = [];
        let lastPos = 0;

        if (searchValue) {
            const searchValuesArray = this.filtersListService
                .getIntelisenseSearchArray(searchValue.trim())
                .sort()
                .reverse();

            let pattern = searchValuesArray.join('|');
            pattern = pattern.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
            const regexSearchValue = new RegExp('(' + pattern + ')', 'gi');

            const matches = [...(value || '').matchAll(regexSearchValue)];

            for (let match of matches) {
                if (lastPos < match.index) {
                    result.push({
                        value: value.substring(lastPos, match.index),
                        highlight: false
                    });
                }

                result.push({
                    value: value.substring(match.index, match.index + match[0].length),
                    highlight: true
                });

                lastPos = match.index + match[0].length;
            }
        }

        if (lastPos < value.length) {
            result.push({
                value: value.substring(lastPos),
                highlight: false
            });
        }

        return result;
    }
}

export interface HighlightItem {
    value: string;
    highlight: boolean;
}
